import React from 'react';
import withNavigateHOC from './navigateHOC';

function Link(props) {
  return React.createElement("a", {
    className: props.isCurrent ? 'selected' : null,
    onClick: props.navigate
  }, props.children);
}

export default withNavigateHOC(Link);